export default {
    apiKey: "AIzaSyBJ6Wuw_NAeR2BldqAymheO4KTCwk5NTz0",
    authDomain: "bazis-sales-kz.firebaseapp.com",
    databaseURL: "https://bazis-sales-kz.firebaseio.com",
    projectId: "bazis-sales-kz",
    storageBucket: "bazis-sales-kz.appspot.com",
    messagingSenderId: "375698944462",
    appId: "1:375698944462:web:965cbc73166e19e1443b9f",
    measurementId: "G-B8287TFLZ3"
}